module.exports = __webpack_public_path__ + "img/LATIN10_22.42e981ae.jpg";